import { CheckCircle, XCircle } from "lucide-react"

export default function SolutionOption({
    index,
    optionKey,
    label,
    text,
    selectedKeys = [],
    correctKeys = [],
    t,
}) {
    const isSelected = selectedKeys.includes(optionKey)
    const isCorrect = correctKeys.includes(optionKey) 

    const baseTone = `${t.border} ${t.soft} ${t.text}`

    const circleTone = isSelected
        ? "bg-blue-500 "
        : "bg-gray-500/20 text-gray-400"

    return (
        <div
            className={`relative rounded-lg border px-4 py-3 flex items-start gap-3 ${baseTone}`}
        >
            <div className="w-4 shrink-0 flex justify-center">
                {isCorrect && (
                    <CheckCircle className="size-7 text-green-600" />
                )}
            </div>
            <div
                className={`size-7 shrink-0 rounded-full flex items-center justify-center text-sm font-semibold ${circleTone}`}
            >
                {index + 1}
            </div>

            <div className="flex-1">
                <span>{text}</span>
            </div>

        </div>
    )
}
